define(['angular', '../module'], function(angular, MODULE_NAME) {

    var templateUrl = require('../views/appSwitcher.template.html');
    var mobileTemplateUrl = require('../views/mobileAppSwitcher.template.html');
    angular.module(MODULE_NAME)
        .directive('ilmnUiAppSwitcher', function() {
            return {
                scope: {
                    appName: '@',
                    dropdownCollapsed: '='
                },
                replace: true, //We have to do this because the CSS is too specific
                controller: UiAppSwitcherController,
                controllerAs: 'vm',
                bindToController: true,
                templateUrl: function ($element, $attrs) {
                    if($attrs.mobileView) {
                        return mobileTemplateUrl;
                    }
                    return templateUrl;
                }
            }
        });

    UiAppSwitcherController.$inject = ['PlatformDomainService', '$location', '$log'];

    function UiAppSwitcherController(platformDomainService, $location, $log) {

        var vm = this;

        vm.$onInit = function() {
            vm.appList = [];

            vm.appLabel = vm.appName.replace(/[\s,]+/g, '<br />');
            vm.platformHost = platformDomainService.getPlatformServiceUrl(true);
            vm.domainName = platformDomainService.getCurrentDomain();

            collectAppList();
        }

        //////////

        function collectAppList() {
            if(!vm.platformHost) {
                return;
            }

            var url = vm.platformHost + '/do/globalAdmin/domainApp/search?domain={domainName}';

            platformDomainService.getDomainInfo(vm.domainName, url).then(function(domainInfo) {
                if (domainInfo) {

                    // TODO
                    // Show Workgroup Admin console only for public domain.
                    // Show workgroup admin console for user who are admins for the current workgroup

                    if (domainInfo.list && angular.isArray(domainInfo.list)) {
                        domainInfo.list.forEach(function(app) {
                            var url;

                            // show only provisioned apps in the dropdown
                            if (app.globalAppTO.allowedToProvision) {

                                if(domainInfo.isPublicDomain) {
                                    url = app.globalAppTO.publicUrl || app.globalAppTO.app_url;
                                }
                                else {
                                    url = app.globalAppTO.app_url;
                                    url = url.replace(app.globalAppTO.url_pattern, vm.domainName);
                                }
                                vm.appList.push({
                                    name: app.globalAppTO.name.replace(/[\s,]+/g, '<br />'),
                                    url: url,
                                    label: app.globalAppTO.description,
                                    class: app.globalAppTO.appColor || 'dflt'
                                });
                            }
                        });
                    }
                }
            });
        }

        vm.toggleCollapsed = function() {
            vm.dropdownCollapsed = !vm.dropdownCollapsed;
        }

    }
})



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-nav/scripts/appSwitcher.directive.js
// module id = 8
// module chunks = 0